var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160839",
    "data-name": "Group 160839",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83757",
    "data-name": "Path 83757",
    d: "M9,0h6a9,9,0,0,1,9,9v6a9,9,0,0,1-9,9H9a9,9,0,0,1-9-9V9A9,9,0,0,1,9,0Z",
    transform: "translate(0.5)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160832",
    "data-name": "Group 160832",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 8,
    y2: 8,
    transform: "translate(0.5)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 8,
    y2: 8,
    transform: "translate(0.5)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCancelIcon);
export default __webpack_public_path__ + "static/media/AICancelIcon.5dc1c143f51e13251fb03d2309c5fe53.svg";
export { ForwardRef as ReactComponent };